import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Assets/Button";
import img from "../../assets/images/login_logo.png";
import { ButtonType } from "../../assets/Button";
import toast from "react-hot-toast";
import { RootDispatch, RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { loginUserWithOtp, sendOtp } from "../../store/slices/authSlice";

const LoginWithOtpPage: React.FC = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const navigate = useNavigate();
  const dispatch: RootDispatch = useDispatch();

  const loading = useSelector((state: RootState) => state.auth.loading);

  const handleSendOtp = async () => {
    if (!mobileNumber) return toast.error("Phone number is required");
    try {
      await dispatch(sendOtp({ mobileNumber })).unwrap();
      setOtpSent(true);
      toast.success("OTP sent successfully");
    } catch (error) {
      console.error("OTP sending failed:", error);
    }
  };

  const handleVerifyOtp = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!otp) {
      return toast.error("OTP is required");
    }
    try {
      await dispatch(loginUserWithOtp({ mobileNumber, otp })).unwrap();

      navigate("/documents", { replace: true });
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen w-full px-4 bg-gray-50">
      <div className="w-full flex flex-col items-center bg-white rounded-2xl max-w-md shadow-md p-8 space-y-6">
        <img src={img} alt="Logo" className="w-48 h-14 object-contain" />
        <h2 className="text-sm font-medium text-center">
          Channel Partner / Delear OTP Login
        </h2>

        <input
          type="tel"
          placeholder="Enter phone number"
          value={mobileNumber}
          onChange={(e) => setMobileNumber(e.target.value)}
          disabled={otpSent}
          className="w-full p-4 border rounded-lg"
        />

        {!otpSent ? (
          <Button
            type={ButtonType.Submit}
            onClick={handleSendOtp}
            className="w-full"
            disabled={loading}
          >
            {loading ? "Sending..." : "Send OTP"}
          </Button>
        ) : (
          <>
            <input
              type="text"
              placeholder="Enter OTP"
              inputMode="numeric"
              pattern="[0-9]*"
              value={otp}
              onChange={(e) => {
                // remove non-numeric
                const value = e.target.value.replace(/\D/g, "");
                setOtp(value);
              }}
              className="w-full p-4 border rounded-lg"
            />

            <Button
              type={ButtonType.Submit}
              onClick={handleVerifyOtp}
              className="w-full"
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default LoginWithOtpPage;
